<template>

  <vx-card>

    <div class="vx-row">
      <div class="vx-col">
        <h5> {{ $t('vdo-live-set-topic.info-title') }}</h5>
      </div>
    </div>

    <vs-divider/>


    <!-- Avatar -->
    <div class="vx-row">

      <!-- Avatar Col -->
      <div class="vx-col">
        <div class="img-container">
          <img class="rounded" :src="liveClassSchedule ? getAvatarUrl(liveClassSchedule.teacher.picturePath):url.noAvatarImage "/>
        </div>
      </div>

      <!-- Information - Col 1 -->
      <div class="vx-col flex-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.teacher-code') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.teacher.code }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.teacher') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.teacher.firstNameLocal + ' ' + liveClassSchedule.teacher.lastNameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('live-class-schedule.on-air-date') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ onAirDate }}
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="font-semibold"> {{ $t('vdo-set.vdo-qty') }}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ totalVdoQty }}
          </div>
        </div>

      </div>
      <!-- /Information - Col 1 -->

      <!-- Information - Col 2 -->
      <div class="vx-col flex-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.subject-code') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.subject.code }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.subject-name') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.subject.nameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('course-outline-registration.sections') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="liveClassSchedule">{{ liveClassSchedule.sectionNo}}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('vdo-set.total-vdo-length') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            {{ totalVdoLength }}
          </div>
        </div>
      </div>

    </div>

  </vx-card>

</template>

<script>
  import {state} from "../data";
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format';
  import {secondToHHMMSSFormat} from '@/utils/data';
  import {getAvatarUrl, config} from "@/utils/upload";

  export default {
    components: {},
    data() {
      return {
        local: state.local,
        vdoLiveSetEdit: state.local.vdoLiveSetEdit,
        getAvatarUrl: getAvatarUrl,
        url: config.url.noAvatarImage,

      }
    },
    computed: {
      liveClassSchedule() {
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          return this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule;
        } else {
          return null;
        }
      },
      onAirDate() {
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          let dateFrom = this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.dateTimeFrom;
          let dateTo = this.vdoLiveSetEdit.vdoLiveSet.liveClassSchedule.dateTimeTo;

          return moment.utc(dateFrom).format(dateTimeFormat.momentYYYYMMDD)
            + ' ' + this.$t('vdo-live-set.time')
            + ' ' + moment.utc(dateFrom).format(dateTimeFormat.momenthhmm)
            + ' - ' + moment.utc(dateTo).format(dateTimeFormat.momenthhmm);
        } else {
          return '-';
        }
      },
      // Still vdoStreamPath, unlike the VdoSetTopic counters that moved to
      // hasVideo(): these are VdoLiveSetTopic rows, and that type has no Bunny
      // columns at all (VdoLiveSetTopic.graphql) -- live-class videos are
      // Wowza-only, so there is nothing here for hasVideo to find.
      totalVdoQty() {
        let totalVdoQty = 0;
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          if (this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics && this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics.length) {
            this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics.forEach(item => {
              totalVdoQty += item.vdoStreamPath ? 1 : 0;
            })
          }
        }
        return totalVdoQty;
      },
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.vdoLiveSetEdit.vdoLiveSet) {
          totalVdoLength = secondToHHMMSSFormat(this.vdoLiveSetEdit.vdoLiveSet.totalVdoLength);
        }
        return totalVdoLength;
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//

      //---------------------------------------- Event Function ------------------------------------------------------//

      //---------------------------------------- Local Function ------------------------------------------------------//
    },
  }
</script>

<style scoped>

</style>
